export const PARAMETERS = 'parameters';

// SSM0010
export const SSM0010_TREATMENT_KEY = 'ssm-0010';
export const SSM0010_GROUP_PARAMETER_KEY = 'group';
export const SSM0010_GROUP_PARAMETER_OPTIONS = Object.freeze({
  control: 'control',
  variant: 'variant'
});

// SSBU-0004
export const SSBU_0004_TREATMENT_KEY = 'ssbu-0004';
export const SSBU_0004_GROUP_PARAMETER_KEY = 'group';
export let SSBU_0004_GROUP_PARAMETER_OPTIONS;

// SSBU-0008
(function (SSBU_0004_GROUP_PARAMETER_OPTIONS) {
  SSBU_0004_GROUP_PARAMETER_OPTIONS["control"] = "control";
  SSBU_0004_GROUP_PARAMETER_OPTIONS["variation"] = "variation";
})(SSBU_0004_GROUP_PARAMETER_OPTIONS || (SSBU_0004_GROUP_PARAMETER_OPTIONS = {}));
export const SSBU_0008_TREATMENT_KEY = 'ssbu-0008';
export const SSBU_0008_GROUP_PARAMETER_KEY = 'group';
export let SSBU_0008_GROUP_PARAMETER_OPTIONS;

// FTS-0011
(function (SSBU_0008_GROUP_PARAMETER_OPTIONS) {
  SSBU_0008_GROUP_PARAMETER_OPTIONS["control"] = "control";
  SSBU_0008_GROUP_PARAMETER_OPTIONS["variation"] = "variation";
})(SSBU_0008_GROUP_PARAMETER_OPTIONS || (SSBU_0008_GROUP_PARAMETER_OPTIONS = {}));
export const FTS_0011_TREATMENT_KEY = 'fts-0011';
export const FTS_0011_GROUP_PARAMETER_KEY = 'group';
export let FTS_0011_GROUP_PARAMETER_OPTIONS;

// FTS-0017
(function (FTS_0011_GROUP_PARAMETER_OPTIONS) {
  FTS_0011_GROUP_PARAMETER_OPTIONS["control"] = "control";
  FTS_0011_GROUP_PARAMETER_OPTIONS["variant"] = "variant";
})(FTS_0011_GROUP_PARAMETER_OPTIONS || (FTS_0011_GROUP_PARAMETER_OPTIONS = {}));
export const FTS_0017_TREATMENT_KEY = 'fts-0017';
export const FTS_0017_GROUP_PARAMETER_KEY = 'group';
export let FTS_0017_GROUP_PARAMETER_OPTIONS;

// FTS-0018
(function (FTS_0017_GROUP_PARAMETER_OPTIONS) {
  FTS_0017_GROUP_PARAMETER_OPTIONS["control"] = "control";
  FTS_0017_GROUP_PARAMETER_OPTIONS["variant"] = "variant";
})(FTS_0017_GROUP_PARAMETER_OPTIONS || (FTS_0017_GROUP_PARAMETER_OPTIONS = {}));
export const FTS_0018_TREATMENT_KEY = 'fts-0018';
export const FTS_0018_GROUP_PARAMETER_KEY = 'group';
export let FTS_0018_GROUP_PARAMETER_OPTIONS;
(function (FTS_0018_GROUP_PARAMETER_OPTIONS) {
  FTS_0018_GROUP_PARAMETER_OPTIONS["control"] = "control";
  FTS_0018_GROUP_PARAMETER_OPTIONS["variant"] = "variant";
})(FTS_0018_GROUP_PARAMETER_OPTIONS || (FTS_0018_GROUP_PARAMETER_OPTIONS = {}));